import { Navigate, createFileRoute } from "@tanstack/react-router";

/** The old Reviews tab lives on as Planner; links to it keep working. */
export const Route = createFileRoute("/_app/projects/$slug/reviews")({
  component: ReviewsRedirect,
  validateSearch: (search: Record<string, unknown>): { review?: string } =>
    typeof search.review === "string" ? { review: search.review } : {},
});

function ReviewsRedirect() {
  const { slug } = Route.useParams();
  const search = Route.useSearch();
  return <Navigate to="/projects/$slug/planner" params={{ slug }} search={search} replace />;
}
